"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gridConfig = require("./grid-config");
var _excluded = ["dataTestId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var forwardRef = _react["default"].forwardRef;
var propTypes = {
  dataTestId: _propTypes["default"].string
};
var defaultProps = {
  dataTestId: null
};
var StyledComponent = _styledComponents["default"].div.withConfig({
  displayName: "grid-row__StyledComponent",
  componentId: "sc-173rt7n-0"
})(["column-gap:", ";display:grid;grid-template-columns:repeat(12,1fr);margin:0 0 ", ";&:last-child{margin:0;}max-width:", ";row-gap:", ";width:100%;@media screen and (min-width:", "){margin:0 0 ", " &:last-child{margin:0;}column-gap:", ";row-gap:", ";}@media screen and (min-width:", "){column-gap:", ";row-gap:", ";}"], _gridConfig.gridConfig.xxs.gutter, _gridConfig.gridConfig.xxs.gutter, _gridConfig.gridContainerConfig.maxWidth, _gridConfig.gridConfig.xxs.gutter, _gridConfig.gridConfig.m.minWidth, _gridConfig.gridConfig.m.gutter, _gridConfig.gridConfig.m.gutter, _gridConfig.gridConfig.m.gutter, _gridConfig.gridConfig.xl.minWidth, _gridConfig.gridConfig.xl.gutter, _gridConfig.gridConfig.xl.gutter);
var GridRow = forwardRef(function (_ref, ref) {
  var dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledComponent, _extends({
    className: "fuse-responsive-grid__row",
    "data-test-id": dataTestId,
    ref: ref
  }, props));
});
GridRow.propTypes = propTypes;
GridRow.defaultProps = defaultProps;
GridRow.displayName = 'GridRow';
var _default = exports["default"] = GridRow;